import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home/Home'
import Market from '../views/market/the-market'
import About from '../views/about'
import Contact from '../views/contact'
import Guide from '../views/Guide'
import Notification from '../views/notification/the-notification'
import QA from '../views/the-QA'
import Auth from '../views/Authentication/Auth'
import Login from '../views/Authentication/login'
import Register from '../views/Authentication/Register'
import ResetPassword from '../views/Authentication/reset-password'
import ForgetPassword from '../views/Authentication/forget-password'
import OtpMobile from '../views/Authentication/otp-mobile'
import OtpEmail from '../views/Authentication/otp-email'
// import KYC from '../views/kyc/kyc'
import theKyc from '../views/kyc/the-kyc'
import Trade from '../views/trade/main-trade'
import GoldTrade from '../views/goldTrade/gold-trade'
import Panel from '../views/panel/panel'
import Dashboard from '../views/panel/components/dashboard'
import Portfolio from '../views/panel/components/portofilo/Portfolio'

import History from "../views/panel/components/history/history";
import Wallet from "../views/panel/components/Wallet/wallet";
import ReferralCode from "../views/panel/components/referralCode"
import Setting from "../views/panel/components/setting";
import OTC from "../views/OTC";
import Wages from "@/views/Wages";
import Fino from "@/views/kyc/Fino";
const that = Vue.prototype;


Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home
    },
    {
        path: '/market',
        name: 'Market',
        component: Market
    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/fino',
        name: 'Fino',
        component:Fino
    },
    {
        path: '/contact',
        name: 'Contact',
        component: Contact
    },
    {
        path: '/otc',
        name: 'OTC',
        component: OTC
    },
    {
        path: '/guide',
        name: 'Guide',
        component: Guide
    },
    {
        path: '/wages',
        name: 'Wages',
        component: Wages
    },

    {
        path: '/qa',
        name: 'QA',
        component: QA
    },
    {
        path: '/notification',
        name: 'Notification',
        component: Notification
    },
    // {
    //     path: '/kyc',
    //     name: 'KYC',
    //     component: KYC
    // },
    {
        path: '/thekyc',
        name: 'TheKYC',
        component: theKyc
    },


//    Authentication
    {
        path: '/auth',
        name: 'Auth',
        component: Auth,
        redirect: {name: 'Login'},
        children: [
            {
                path: '/auth',
                redirect: '/auth/login'
            },
            {
                path: 'login',
                name: 'Login',
                component: Login,
            },
            {
                path: 'register',
                name: 'Register',
                component: Register,
            },
            {
                path: 'resetPassword',
                name: 'ResetPassword',
                component: ResetPassword,
            },
            {
                path: 'forgetPassword',
                name: 'ForgetPassword',
                component: ForgetPassword,
            },
            {
                path: 'otpMobile',
                name: 'OtpMobile',
                component: OtpMobile,
            },
            {
                path: 'otpEmail',
                name: 'OtpEmail',
                component: OtpEmail,
            },

        ]
    },
    {
        path: '/fromgoogle',
        name: 'FromGoogle',
        component: ()=> import('@/views/Authentication/FromGoogle')
    },

//  trade
    {
        path: '/trade/:tradeTo/:tradeFrom',
        name: 'Trade',
        component: Trade,
        props:true
    },

    {
        name:'Trade',
        path: '/trade',
        redirect: '/trade/TOMAN/BITCOIN',
    },

    //gold trade
    {
        path: '/goldTrade',
        name: 'GoldTrade',
        component: GoldTrade,
    },


    //panel
    {
        path: '/panel',
        name: 'Panel',
        component: Panel,
        children: [
            {
                path: '/panel',
                redirect: '/panel/dashboard'
            },
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: Dashboard,
            },
            {
                path: 'portfolio',
                name: 'Portfolio',
                component: Portfolio,
            },
            {
                path: 'portfolioEx',
                name:'PortfolioEx',
                component: ()=> import('@/views/panel/components/portofilo/Exchange/portfolioEx'),
            },
            {
                path: 'setting',
                name: 'Setting',
                component: Setting,
            },
            {
                path: 'history',
                name: 'History',
                component: History,
            },
            {
                path: 'wallet',
                name: 'Wallet',
                component: Wallet,
            },
            {
                path: 'walletEx',
                name: 'WalletEx',
                component: ()=> import('@/views/panel/components/Wallet/Exchange/wallet'),
            },
            {
                path: 'redirect-from-banks',
                name: 'RedirectFromBanks',
                component: ()=> import('@/views/panel/components/Wallet/RedirectFromBank'),
            },
            {
                path:'/redirect-from-banks',
                redirect:'/profile/redirect-from-banks'
            },

            {
                path: 'referralCode',
                name: 'ReferralCode',
                component: ReferralCode,
            },

        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
})
//the routes that disabled in default
// const disabledRoutes = ["otc", "trade", "profile"];
/*
 * this is the guard for routes that shouldn't
 * load without Login
 * */
const forLogin = [
    "Panel",
    "Dashboard",
    "Portfolio",
    "Setting",
    "History",
    "Wallet",
    "ReferralCode",
    "Trade",
    "GoldTrade",

    // "settings",
    // "profile",
];
//Users that did not authorized must not access these pages
const unAuthorUser = [
    // "Panel",
    "History",
    "Wallet",
    // "Dashboard",
    "Portfolio",
    // "wallet",
    // "otc",
    "Trade",
];
const otp = [
    // "SendPhone", "SendMail"
];
const auth = [
    // 'Login',
    // "SignUp",
    // "Forget",
];

router.beforeEach(async (to, from, next) => {
    that.state.loading = true;

    if (!that.state.coins) {
        await that.$getCoins();
    }

    if (that.state.token) {
        if (!that.state.gotten) {
            that.state.loading = true;
            await that.$getuserInfo();
            await that.$getuserLevels();
            that.state.loading = true;
            await that.$getFees();
        }

        that.state.loading = true;
        if (that.state.userInfo.supervisor && disabledRoutes.includes(to.name)) {
            that.$error(
                "",
                "با عرض پوزش قابلیت مورد نظر برای بازار گردان غیر فعال است"
            );
            next(from);
        }
        if (from.name === "Blog") {
            await window.open(to.fullPath, "_self");
        } else if (otp.includes(to.name) || auth.includes(to.name)) {
            next({ name: "Home" });
        } else if (to.name === "Trade") {
            if (!to.params.tradeFrom || !to.params.tradeTo) {
                next("/trade/TOMAN/BITCOIN");
            } else {
                try {
                    that.state.loading = true;
                    await that.$axios(
                        `/markets/${to.params.tradeFrom}_${to.params.tradeTo}`
                    );
                    next();
                } catch (e) {
                    if (e.response.data.message === "MARKET_IS_NOT_ACTIVE") {
                        if (otp.includes(from.name)) {
                            next({ name: "Home" });
                        } else {
                            await that.$error("بازار غیرفعال است");
                            next(from);
                        }
                    }
                }
            }
        } else {
            if (that.state.userInfo.authorized) {
                next();
            } else {
                if (otp.includes(from.name) && to.name !== "Account") {
                    next({ name: "Account" });
                } else if (unAuthorUser.includes(to.name)) {
                    that.state.loading = false;
                    const res = await that.$error(
                        "عدم دسترسی",
                        "برای دسترسی به این بخش نیاز است ابتدا حساب شما تکمیل و تایید شود",
                        "error",
                        "حساب کاربری"
                    );
                    if (res.isConfirmed) {
                        next("/thekyc");
                    } else {
                        next(from);
                    }
                } else next();
            }
        }
    } else {
        if (
            (otp.includes(to.name) && !Vue.$cookies.isKey("username")) ||
            forLogin.includes(to.name)
        )
            next('/auth/login');
        else {
            next();
        }
    }
    that.state.loading = false;
});




export default router
